import { getClientLogoDefinition, normalizeClientLogoSrc } from "@/lib/clientLogos"

interface ClientLogoProps {
  alt: string
  className?: string
  src: string | null | undefined
}

export function ClientLogo({ alt, className, src }: ClientLogoProps) {
  const normalizedSrc = normalizeClientLogoSrc(src)
  const definition = getClientLogoDefinition(normalizedSrc)

  if (!normalizedSrc || !definition) return null

  return (
    <img
      data-client-logo-image
      src={normalizedSrc}
      alt={alt}
      width={definition.width}
      height={definition.height}
      className={className}
      decoding="async"
    />
  )
}
